import { useState } from 'react';
import { Tabs, ITab } from './Tabs';
import { LocationList } from './LocationList';
import { TagList } from './TagList';
import { FilterButton } from './FilterButton';
import { useTags } from '../hooks/tagHooks';

export interface ITabbedPanelProps {
  selectedLocationId: string | null;
  selectedTagFilters: string[];
  onSelectLocation: (locationId: string) => void;
  onUnselectLocation: () => void;
  onRemoveLocation: (id: string) => void;
  onCreateAndApplyTag: (locationId: string, name: string) => void;
  onTagFilterChange: (tagIds: string[]) => void;
  onExport: () => void;
}

export function TabbedPanel({
  selectedLocationId,
  selectedTagFilters,
  onSelectLocation,
  onUnselectLocation,
  onRemoveLocation,
  onCreateAndApplyTag,
  onTagFilterChange,
  onExport,
}: ITabbedPanelProps) {
  const { data: tags = [] } = useTags();
  const [activeTab, setActiveTab] = useState('locations');

  const tabs: ITab[] = [
    {
      id: 'locations',
      label: 'Locations',
      content: (
        <LocationList
          selectedLocationId={selectedLocationId}
          selectedTagFilters={selectedTagFilters}
          onSelectLocation={onSelectLocation}
          onUnselectLocation={onUnselectLocation}
          onRemoveLocation={onRemoveLocation}
          onCreateAndApplyTag={onCreateAndApplyTag}
          onExport={onExport}
        />
      ),
    },
    {
      id: 'tags',
      label: 'Tags',
      content: <TagList />,
    },
  ];

  return (
    <div className="w-full h-1/2">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        rightContent={
          activeTab === 'locations' ? (
            <FilterButton
              availableTags={tags}
              selectedTagFilters={selectedTagFilters}
              onTagFilterChange={onTagFilterChange}
            />
          ) : null
        }
      />
    </div>
  );
}
